import image_01 from './01.jpeg'
import image_02 from './02.jpg'
import image_03 from './03.jpeg'

export const gallery = {
  image_01,
  image_02,
  image_03,
};
